import { render, staticRenderFns } from "./RuleName.vue?vue&type=template&id=90f3ac40"
import script from "./RuleName.vue?vue&type=script&lang=js"
export * from "./RuleName.vue?vue&type=script&lang=js"
import style0 from "./RuleName.vue?vue&type=style&index=0&id=90f3ac40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports